export default __webpack_public_path__ + "ee8468c62e18b59f763ab7dd45708a3a.svg";